































import { Component, Vue, Prop } from 'vue-property-decorator'
import TopMenu from './Components/TopMenu.vue'
import TableMenu from './Components/TableMenu.vue'
import Pagination from '@/app/ui/components/Pagination/index'
import { FAQModule } from '@/app/store/modules/faq'

@Component({
  name: 'FAQ',
  components: {
    'top-menu': TopMenu,
    'table-menu': TableMenu,
    pagination: Pagination,
  },
})
export default class extends Vue {
  public searchInput = ''
  private selected = []

  public created() {
    FAQModule.paginationParam.search = ''
    this.getData()
  }
  public getData() {
    FAQModule.getFAQData()
  }

  public get faqData() {
    return FAQModule.faqData
  }

  public get isLoading() {
    return FAQModule.isLoading
  }
  public get page() {
    return FAQModule.Pages
  }
  public get limit() {
    return FAQModule.Limit
  }

  public get fields() {
    return FAQModule.fields
  }

  private onPageNumChanged(limit: any) {
    FAQModule.paginationParam.paging.limit = limit
    this.getData()
  }

  private funcFirstPage() {
    FAQModule.paginationParam.paging.page = 1
    this.getData()
  }

  private funcPrevPage() {
    FAQModule.paginationParam.paging.page =
      FAQModule.paginationParam.paging.page - 1
    this.getData()
  }
  private funcNextPage() {
    FAQModule.paginationParam.paging.page =
      FAQModule.paginationParam.paging.page + 1
    this.getData()
  }

  private funcLastPage() {
    FAQModule.paginationParam.paging.page =
      (this.faqData.pagination && this.faqData.pagination.pageCount) || 0
    this.getData()
  }
  private onRowSelected(items) {
    this.selected = items
  }
  public clearTableStatus: boolean = false
  public clearRowSelected() {
    this.selected = []
    if (this.clearTableStatus === false) {
      this.clearTableStatus = true
    } else {
      this.clearTableStatus = false
    }
  }
  private funcSearch(item) {
    FAQModule.paginationParam.search = item
    this.getData()
  }
}
